export default [
  {
    name: 'bank/collections',
    path: '/bank/collections',
    meta: { design: { classes: ['fill-height', 'bg--linear-gradient'] } },
    component: () => import('@/pages/bank/Collections.vue'),
  },
  {
    name: 'bank/withdrawal',
    path: '/bank/withdrawal',
    component: () => import('@/pages/bank/Withdrawal.vue'),
  },
  {
    name: 'bank/withdrawal-info',
    path: '/bank/withdrawal-info',
    component: () => import('@/pages/bank/WithdrawalInfo.vue'),
  },
]
